import React, { useMemo } from "react";
import { useActivitiesCheckoutProps } from "@capone/portal";
import { useTheme } from "@material-ui/core";
import { RouteComponentProps } from "react-router-dom";
import {
  ExperimentState,
  ExperiencesModuleProps,
  CoreActivitiesCheckout,
} from "redmond";
import { isCorpTenant, useUserContext } from "@capone/common";
import App from "../../../../../../cap1-modules/experiences-module/src/App";

import config from "../../../utils/config";
import { colors as caponeColors } from "../../../utils/capone/colors";
import { colors as corpColors } from "../../../utils/capone-corporate/colors";

interface IExperiencesModuleProps extends RouteComponentProps {
  language: string;
  experiments?: ExperimentState;
  core?: CoreActivitiesCheckout;
}

const ExperiencesModule = (props: IExperiencesModuleProps) => {
  const { language, experiments, core, ...routerProps } = props;
  const { history } = routerProps;
  const theme = useTheme();

  const { sessionInfo, logo, isRewardsDisabled } = useUserContext(
    config.TENANT
  );

  const moduleProps: ExperiencesModuleProps = useMemo(
    () => ({
      colors: isCorpTenant(config.TENANT) ? corpColors : caponeColors,
      experiments,
      language,
      theme,
      baseHistory: history,
      clientAssets: {
        sessionInfo,
        logo: <img src={logo?.src} alt={logo?.alt} />,
        isRewardsDisabled,
      },
      isAgentPortal: config.ptIsAgentPortal,
      core,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isRewardsDisabled]
  );

  return <App {...moduleProps} />;
};

export const LegacyActivitiesBooking = (
  props: React.ComponentProps<typeof ExperiencesModule>
) => {
  const checkoutProps = useActivitiesCheckoutProps();
  return <ExperiencesModule {...props} core={checkoutProps} />;
};
